import {GetterTree} from 'vuex'
// @ts-ignore
import {IMaintenanceState} from './maintenance-state.store'
import {IRootState} from '../root-state.store'
import {CrudStatus} from '../../common/enums'

export const getters: GetterTree<IMaintenanceState, IRootState> = {
  isLoading: (state: IMaintenanceState) => {
    return state.isLoading
  },

  maintenance: (state: IMaintenanceState) => {
    return state.maintenance
  },
  maintenanceTemplate: (state: IMaintenanceState) => {
    return state.maintenanceTemplate
  },
  maintenanceIntervalTypes: (state: IMaintenanceState) => {
    return state.maintenanceIntervalTypes
  },
  maintenanceTemplates: (state: IMaintenanceState) => {
    return state.maintenanceTemplates
  },
  maintenanceSearchParams: (state: IMaintenanceState) => {
    return state.maintenancesSearchParams
  },
  maintenances: (state: IMaintenanceState) => state.maintenances,
  activityStatus:(state: IMaintenanceState) => state.activityStatus,
  equipment: (state: IMaintenanceState) => {
    return state.equipment
  },
  equipments: (state: IMaintenanceState) => {
    return state.equipments
  },
  equipmentCrudActionStatus: (state: IMaintenanceState): CrudStatus => {
    return state.crudActionStatus
  },
  currentEquipment: (state: IMaintenanceState) => {
    return state.currentEquipment
  },
  service: (state: IMaintenanceState) => {
    return state.service
  },
  attributeToEdit: (state: IMaintenanceState) => {
    return state.attributeToEdit
  },
  currentAttribute: (state: IMaintenanceState) => {
    return state.currentAttribute
  },
  blockEquipmentParameter: (state: IMaintenanceState) => {
    return state.blockEquipmentParameter
  },
  blockEquipmentData: (state: IMaintenanceState) => {
    return state.blockEquipmentData
  },
  blockVehicleFleetParameter: (state: IMaintenanceState) => {
    return state.blockVehicleFleetParameter
  },
  blockVehicleFleet: (state: IMaintenanceState) => {
    return state.blockVehicleFleet
  }
}



// WEBPACK FOOTER //
// ./src/store/maintenance/maintenance-getters.store.ts